import Events from '@utilities/events';

const CLOSE_MODAL_BUTTON_HOOK = '[js-hook-job-alert-button-modal-close]';

class jobAlertForm {
    constructor(element) {
        this.element = element;
        this.closeModalButtons = [...this.element.querySelectorAll(CLOSE_MODAL_BUTTON_HOOK)];

        const shouldOpenModal = window.location.search.indexOf('gcs-job-alert-subscription-modal-showing') !== -1;

        if (shouldOpenModal) Events.$trigger('modal[job-alert-modal]::open');

        this.bindEvents();
    }

    /**
     * Bind all events
     */
    bindEvents() {
        this.closeModalButtons.forEach(button => {
            button.addEventListener('click', () => {
                Events.$trigger('modal[job-alert-modal]::close');
            });
        });
    }
}

export default jobAlertForm;
